import React, { Component } from 'react'
import { connect } from 'react-redux'

// Actions
import { getSparePartsOrdering } from '../../../actions/spareparts'

// Elements
import Overlay from '../../elements/overlay'
import TabBar from '../../elements/tabBar'
import TabItem from '../../elements/tabItem'

// Components
import OverlayHeader from '../../components/OverlayHeader'
import MatchingSparePartsOverlay from '../matchingSpareParts'

// Tabs
import Ordering from './tabs/ordering'
import Receiving from './tabs/receiving'
// import Control from './tabs/control'

import './spareparts.scss'
import { translation } from '../../../utils/helpers'

class SparePartsOverlay extends Component {
  constructor (props) {
    super(props)

    this.state = {
      activeTabIndex: 0
    }

    this.getTabs = this.getTabs.bind(this)
    this.openOverlay = this.openOverlay.bind(this)
    this.updateSpareParts = this.updateSpareParts(this)
  }

  componentWillUnmount () {

  }

  getTabs () {
    const tabs = []

    let orderingTabTitleId = 16435
    if (this.props.auth.permissions.DracarUsable) {
      orderingTabTitleId = 16646
    }

    tabs.push(
      {
        titleId: orderingTabTitleId, // Dictionary key for the tabbar item
        getComponent: (props) => { return <Ordering {...props} orderId={this.props.order.Id} /> } // Component to render when tab is active
      },
      {
        titleId: 16434,
        getComponent: (props) => { return <Receiving {...props} orderId={this.props.order.Id} /> }
      }
    )

    return tabs
  }

  openOverlay () {
    this.props.openOverlay('MatchingPartsOverlay')
  }

  updateSpareParts () {
    this.props.getSparePartsOrdering({ OrderId: this.props.order.Id }).then(res => {
      this.setState({ isLoading: false })
      // this.handleErrors(res) // function not implemented
    })
  }

  renderHeader () {
    const renderTab = (tab, index) => {
      const changeTab = () => {
        this.setState({
          activeTabIndex: index
        })
      }
      let isActive = this.state.activeTabIndex === index
      return <TabItem key={index} labelText={translation(tab.titleId)} active={isActive} onClick={changeTab} />
    }

    let order = this.props.order
    let reportId = null
    let hasForsiReport = order.Report !== null && order.Report.ReportType === 1
    let hasRPReport = order.Report !== null && order.Report.ReportType === 2

    // if (order.HasForsiReport) reportId = order.ForsiReportId
    // else if (order.RpReport) reportId = order.RpReport.FullReportId

    if (hasForsiReport || hasRPReport) reportId = order.Report.ReportUid
    // else if (hasRPReport) reportId = order.Report.ReportUid

    if (reportId != null) {
      reportId = `${reportId.substring(0, 2)} ${reportId.substring(2, 7)} ${reportId.substring(7, 9)} ${reportId.substring(9, 13)} ${reportId.substring(13)}`
    }

    return (
      <OverlayHeader overlayId='SparePartsOverlay' onClose={this.props.onClose}>
        <div className='bottom'>
          <TabBar>
            {this.getTabs().map(renderTab)}
          </TabBar>
        </div>
        <div className='top topHeaderInfo'>
          <div>
            <span>{order.RegNumber}</span>
          </div>
          <div>
            <span>{`${order.BrandName.Name || ''} ${order.Model || ''} · ${order.ChassisNumber || ''}`}</span>
            <span>{`${order.CustomerName || ''} · ${order.CreatedByName || ''}`}</span>
          </div>
          <div>
            <span>{`${order.InsuranceCompanyName || ''}`}</span>
            <span>{`${translation(459)} ${reportId || ''}`}</span>
          </div>
        </div>
      </OverlayHeader>
    )
  }

  render () {
    return (
      <Overlay overlayId='SparePartsOverlay' extraClassName='spareparts-overlay' noContentScroll>
        {this.renderHeader()}
        <div className='content'>
          {this.getTabs()[this.state.activeTabIndex].getComponent()}
        </div>
        <div className='matchingPartOverlay'>
          <MatchingSparePartsOverlay order={this.props.order} onClose={this.updateSpareParts} />
        </div>
      </Overlay>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    headerInfo: state.common.headerInfo
  }
}

SparePartsOverlay.propTypes = {
  order: React.PropTypes.object.isRequired
}

export default connect(mapStateToProps, {
  getSparePartsOrdering
})(SparePartsOverlay)



// WEBPACK FOOTER //
// ./src/app/shared/overlays/spareParts/index.js